import React from 'react'
const Icon = () => (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_12295_303)">
      <path
        d="M12.5 0C5.88321 0 0.5 5.38321 0.5 12C0.5 18.6168 5.88321 24 12.5 24C19.1168 24 24.5 18.6168 24.5 12C24.5 5.38321 19.1169 0 12.5 0ZM12.5 22.7027C9.56028 22.7027 6.89373 21.5111 4.95757 19.5859C4.18437 18.8171 3.52801 17.931 3.01695 16.9572C2.23856 15.4743 1.79731 13.7878 1.79731 12C1.79731 6.09852 6.59852 1.29731 12.5 1.29731C15.2992 1.29731 17.8504 2.37798 19.7595 4.14346C20.7494 5.05872 21.5668 6.15787 22.1562 7.38642C22.8267 8.7842 23.2027 10.349 23.2027 12C23.2027 17.9015 18.4015 22.7027 12.5 22.7027Z"
        fill="currentColor"
      />
      <path
        d="M8.58113 10.6215C9.29762 10.6215 9.87844 10.0407 9.87844 9.32417C9.87844 8.60768 9.29762 8.02686 8.58113 8.02686C7.86464 8.02686 7.28381 8.60768 7.28381 9.32417C7.28381 10.0407 7.86464 10.6215 8.58113 10.6215Z"
        fill="currentColor"
      />
      <path
        d="M16.6082 10.6215C17.3247 10.6215 17.9055 10.0407 17.9055 9.32417C17.9055 8.60768 17.3247 8.02686 16.6082 8.02686C15.8917 8.02686 15.3109 8.60768 15.3109 9.32417C15.3109 10.0407 15.8917 10.6215 16.6082 10.6215Z"
        fill="currentColor"
      />
      <path
        d="M12.477 18.6485C14.9868 18.6485 17.3921 17.365 18.7693 15.2339L17.6796 14.5298C16.415 16.4867 14.1018 17.5788 11.7855 17.3116C9.98048 17.1034 8.31124 16.0635 7.32017 14.5298L6.23059 15.2339C7.4298 17.0898 9.45085 18.3482 11.6368 18.6004C11.9175 18.6327 12.1977 18.6485 12.477 18.6485Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_12295_303">
        <rect width="24" height="24" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
)
export default Icon
